module.exports = __webpack_public_path__ + "static/img/logo-maintenance.bd316e7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo-maintenance.png
// module id = K93w
// module chunks = 11